// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateNewTransfer = (data) => ({
    data,
    type: actions.UPDATE_NEW_TRANSFER_SUCCESS,
});
